import {
  CREATE_OFFICE_SERVER_PENDING,
  CREATE_OFFICE_SERVER_SUCCESS,
  CREATE_OFFICE_SERVER_ERROR,
  RESET_CREATE_OFFICE_SERVER,
  CreateOfficeServerState,
  CreateOfficeServerActionType,
} from "./types";

const initialState: CreateOfficeServerState = {
  createOfficeServerPending: false,
  createOfficeServerError: null,
  createdOfficeServerDetails: null
}

export function CreateOfficeServerReducer(
  state: CreateOfficeServerState = initialState,
  action: CreateOfficeServerActionType
): CreateOfficeServerState {
  switch (action.type) {

    case CREATE_OFFICE_SERVER_PENDING: {
      return {
        ...state,
        createOfficeServerPending: true,
      };
    }

    case CREATE_OFFICE_SERVER_SUCCESS: {
      const { payload } = action;
      const { createdOfficeServerDetails } = payload;

      return {
        ...state,
        createOfficeServerPending: false,
        createOfficeServerError: null,
        createdOfficeServerDetails,
      };
    }

    case CREATE_OFFICE_SERVER_ERROR: {
      const { payload } = action;
      const { error } = payload;

      return {
        ...state,
        createOfficeServerPending: false,
        createOfficeServerError: error,
      };
    }

    case RESET_CREATE_OFFICE_SERVER: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
